export enum ComplaintsActionTypes {
  API_RESPONSE_SUCCESS = "@@complaints/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@complaints/API_RESPONSE_ERROR",

  GET_COMPLAINTS = "@@complaints/GET_COMPLAINTS",
  CHANGE_STATUS = "@@complaints/CHANGE_STATUS",
}
